export class CustomParamsStartEndMonthYearModel {
  StartMonth: number;
  StartYear: number;
  EndMonth: number;
  EndYear: number;
}
